<template>
  <div class="dropdown" v-bind:class="[position, classes]">
    <div class="trigger" v-on:click.stop="toggleDropdown">
      <slot name="trigger"></slot>
    </div>

    <div v-if="dropdownShown" class="dropdown-menu">
      <div class="dropdown-body" @click.stop="hideDropdown">
        <slot name="dropdown-body"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    position: {
      type: String,
      default: 'bottom left',
    },
    classes: {
      type: String,
    },
  },

  data() {
    return {
      dropdownShown: false,
    };
  },

  beforeUnmount() {
    document.body.removeEventListener('click', this.check);
  },

  methods: {
    check(e) {
      if (!this.$el.contains(e.currentTarget)) {
        setTimeout(this.hideDropdown);
      }
    },

    toggleDropdown() {
      if (this.dropdownShown) {
        this.hideDropdown();
      } else {
        this.dropdownShown = true;
        document.body.addEventListener('mouseup', this.check);
      }
    },

    hideDropdown() {
      this.dropdownShown = false;
      document.body.removeEventListener('mouseup', this.check);
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown {
  &.dropdown-menu-w-a {
    .dropdown-menu {
      width: auto;
    }
  }

  &.dropdown-menu-p-0 {
    .dropdown-menu {
      padding: 0;
    }
  }

  hr {
    margin: 0.25rem 0;
  }
}
</style>
